
















import { computed, defineComponent } from "@vue/composition-api";

interface Props {
  context: Record<string, string>;
}

export default defineComponent<Props>({
  name: "ContextTooltip",
  props: {
    context: { type: Object, required: true }
  },
  setup(props: Props) {
    const calculateDisplay = (key: string, value: string) => {
      if (key === "allergy") return "Allergy";
      return value.replace(/^\w/, c => c.toLocaleUpperCase());
    };

    const list = computed(() =>
      Object.entries(props.context).map(([key, value]) =>
        calculateDisplay(key, value)
      )
    );

    return { list };
  }
});
